'use client';

import React, { JSX } from 'react';

import { WarningTriangle, Close } from '@videoblocks/react-icons';

export default function MaintenanceBanner(): JSX.Element | null {
    const [showBanner, setShowBanner] = React.useState(true);

    React.useEffect(() => {
        const isBannerVisible = sessionStorage.getItem('show-maintenance-banner') !== 'false';
        setShowBanner(isBannerVisible);
    }, []);

    if (!showBanner) {
        return null;
    }

    const hideBanner = () => {
        sessionStorage.setItem('show-maintenance-banner', 'false');
        setShowBanner(false);
    };

    return (
        <div
            role="alert"
            data-testid="maintenance-banner"
            className="flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2"
        >
            <WarningTriangle className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
            <p className="flex-1 text-sm">
                We will be performing routine maintenance on May 21st starting at 8 PM ET. The expected duration is 3
                hours. During this period, the Web Application and API will be unavailable. Thank you for your patience
                as we work to improve our services.
            </p>
            <button
                type="button"
                onClick={hideBanner}
                aria-label="Dismiss maintenance notification"
                className="p-1 hover:bg-blue-200 rounded transition-colors flex-shrink-0"
            >
                <Close className="w-5 h-5" aria-hidden="true" />
            </button>
        </div>
    );
}
